export default __webpack_public_path__ + "static/media/controls_not_applicable.8041f260.svg";